var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsDateString, IsEnum, IsNumber, IsOptional, IsString, Length, Max, Min, ValidateNested, } from 'class-validator';
import { CreateVehicleModelAudioDto, CreateVehicleModelKeyOptionDto, CreateVehicleModelOptionDto, } from '../../../classes/vehicle-model';
import { VehicleModelState } from '../../../enums';
export class CreateVehicleDto {
}
__decorate([
    IsString(),
    Length(1, 10),
    __metadata("design:type", String)
], CreateVehicleDto.prototype, "vehicleNumber", void 0);
__decorate([
    IsDateString(),
    __metadata("design:type", String)
], CreateVehicleDto.prototype, "registeredAt", void 0);
__decorate([
    IsEnum(VehicleModelState),
    IsOptional(),
    __metadata("design:type", String)
], CreateVehicleDto.prototype, "state", void 0);
__decorate([
    IsNumber(),
    Min(2000),
    Max(2100),
    IsOptional(),
    __metadata("design:type", Number)
], CreateVehicleDto.prototype, "age", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], CreateVehicleDto.prototype, "mileage", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateVehicleDto.prototype, "inspectionDue", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateVehicleDto.prototype, "expirationDate", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreateVehicleDto.prototype, "color", void 0);
__decorate([
    ValidateNested(),
    Type(() => CreateVehicleModelAudioDto),
    __metadata("design:type", CreateVehicleModelAudioDto)
], CreateVehicleDto.prototype, "audio", void 0);
__decorate([
    ValidateNested(),
    Type(() => CreateVehicleModelOptionDto),
    __metadata("design:type", CreateVehicleModelOptionDto)
], CreateVehicleDto.prototype, "vehicleOption", void 0);
__decorate([
    ValidateNested(),
    Type(() => CreateVehicleModelKeyOptionDto),
    __metadata("design:type", CreateVehicleModelKeyOptionDto)
], CreateVehicleDto.prototype, "keyOption", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreateVehicleDto.prototype, "memo", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateVehicleDto.prototype, "vehicleModelId", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateVehicleDto.prototype, "garageId", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateVehicleDto.prototype, "branchId", void 0);
